import { render } from "./Thumbnailcreator.vue?vue&type=template&id=9fc9a6a6"
import script from "./Thumbnailcreator.vue?vue&type=script&lang=js"
export * from "./Thumbnailcreator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"backend/vue/thumbnailcreator/Thumbnailcreator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9fc9a6a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9fc9a6a6', __exports__)) {
    api.reload('9fc9a6a6', __exports__)
  }
  
  module.hot.accept("./Thumbnailcreator.vue?vue&type=template&id=9fc9a6a6", () => {
    api.rerender('9fc9a6a6', render)
  })

}


export default __exports__